<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="p-3 border-top merge-request-discussion__item">
    <div class="d-flex">
      <a :href="'/user/' + reply.author.username">
        <img
          :src="reply.author.avatar"
          class="rounded-circle avatar-image"
          height="40"
          width="40"
        />
      </a>
    </div>
    <div class="d-flex flex-column w-100 overflow-hidden">
      <div class="d-flex mb-2">
        <div class="mr-2">
          <a
            class="text-body f5"
            :href="'/user/' + reply.author.username"
          >
            <span class="font-weight-bolder">{{ reply.author.fullName }}</span>
            <span class="mr-1 text-muted text-decoration-none">@{{ reply.author.username }}</span>
          </a>
          <span class="text-muted">·</span>
          <span class="f6 text-muted">
            {{ $moment.utc(reply.createdAt).fromNow() }}
          </span>
        </div>
        <button
          v-if="hasDiscussionDeleteAccess"
          type="button"
          class="d-flex align-items-center merge-request-discussion__item-btn btn btn-link text-danger ml-auto mb-auto"
          @click="deleteDiscussionReply"
        >
          <i class=" gf-icon gf-icon-trash" />
        </button>
      </div>
      <div
        class="f5 markdown-body"
        v-html="reply.message"
      />
    </div>
  </div>
</template>

<script>
import MRService from '@shared/services/merge-request.service';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
// import Ref from '@shared/services/reference.service';

export default {
  name: 'MergeRequestDiscussionReply',
  props: ['reply'],
  data() {
    return {
      hasDiscussionDeleteAccess: false
    };
  },
  computed: {
    getRefUsers() {
      return this.$store.getters.getReferenceUsers || {};
    }
  },
  mounted() {
    this.checkAccess();
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    checkAccess() {
      const metaUuid = document.querySelector('head meta[name="uuid"]');
      let uuid = '';
      let aid = '';

      if (metaUuid) {
        uuid = metaUuid.content;
        aid = this.reply.author.id;
      }

      if (
        (uuid.length > 0 && uuid === aid) ||
        this.getActionAvailabilityFlag(ACTION_ENUM.DELETE_DISCUSSION)
      ) {
        this.hasDiscussionDeleteAccess = true;
      }
    },
    deleteDiscussionReply(e) {
      MRService.deleteIssueReply(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id,
        this.reply.id
        // eslint-disable-next-line no-return-assign
      ).then((res) => (this.result = res));

      if (this.reply.discussionUuid) {
        const item = e.target.closest('.merge-request-discussion__item');
        item.classList.add('--hidden');
      }
      this.$emit('deleteDiscussion', this.reply);
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.merge-request-discussion__item {
  $this: '.merge-request-discussion__item';

  max-height: 100000px;
  display: grid;
  grid-template-columns: 40px auto;
  gap: 1rem;
  overflow: hidden;

  &.--hidden {
    max-height: 0;
    display: none !important;
  }

  #{$this}-btn {
    padding: 0;
    width: 20px;
    white-space: nowrap;
    font-size: 13px;
  }
}
</style>
